import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { ConfigurationChangelogObjectType } from '@rossum/api-client/configurationChangelog';
import { api } from '../../../lib/apiClient';
import { QUERY_KEY_CONFIGURATION_CHANGELOG } from './useConfigurationChangelog';

type UseConfigurationChangelogDetailParams = {
  objectType: ConfigurationChangelogObjectType;
  objectId: number;
  versionId: number;
  enabled?: boolean;
};

export const useConfigurationChangelogDetail = ({
  objectType,
  objectId,
  versionId,
  enabled,
}: UseConfigurationChangelogDetailParams) =>
  useQuery({
    queryKey: [
      QUERY_KEY_CONFIGURATION_CHANGELOG,
      'detail',
      { objectType, objectId, versionId },
    ] as const,
    queryFn: () =>
      api.request(
        endpoints.configurationChangelog.list({
          objectType: [objectType],
          objectId: [objectId],
          versionIdRangeMax: versionId,
          includeSnapshot: true,
          pageSize: 2,
        })
      ),
    enabled,
  });
